export default "/fonts/Urbanist-Black.ttf?fbde978d1e5ed6e62045900640374cb7";